import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'cho';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Ha ocurrido un error. Por favor vuelve a intentarlo nuevamente";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-cho-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-cho rounded mx-auto d-block" />
        <div className="cho-separator"></div>
        <h3>TUS SERIES, PELÍCULAS Y PROGRAMAS <br />FAVORITOS CUANDO QUIERAS.</h3>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="cho-form-container">
            <Row className="cho-form-body">
              <Col sm="4" xs="4" md="4" style={{ padding: '0px' }}>
                <label>USUARIO:</label>
              </Col>
              <Col sm="8" xs="8" md="8">
                <Input
                  className="user-input-cho"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="cho-form-body">
              <Col sm="4" xs="4" md="4" style={{ padding: '0px' }}>
                <label>CONTRASEÑA:</label>
              </Col>
              <Col sm="8" xs="8" md="8">
                <Input
                  className="pass-input-cho"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="cho-form-footer">
              <Col sm="12" xs="12" md="12" style={{ textAlign: 'center' }}>
                {!onLogin ? (
                  <div>
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-cho"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>
              <Col sm='12' xs='12' md='12' style={{ marginTop: '20px' }}>
                <p class="texto_formulario_play center" style={{ textAlign: 'center', fontSize: '11px', fontWeight: 'bold', lineHeight: '1' }}>
                  UTILIZÁ EL MISMO USUARIO Y CONTRASEÑA<br />DE NOW EXPRESS
                </p>
              </Col>
              <Col sm="12" xs="12" md="12" style={{ marginTop: '20px' }}>
                {checkDeviceIOS() ? '' :
                  <p className="cho-register-link">
                    SI AÚN NO ESTÁS REGISTRADO <a href="https://www.express.com.ar/home" target="_blank" rel="noopener noreferrer">HACELO AQUÍ.</a>
                  </p>
                }
              </Col>
              <Col sm="12" xs="12" md="12">
                <p className="cho-recovery-pass-link">¿OLVIDASTE TU USUARIO O CONTRASEÑA?
                  <a href="https://www.express.com.ar/home" target="_blank" rel="noopener noreferrer"> RECUPERAR</a>
                </p>
              </Col>
              <div className="messages-container cho-error">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm);
